import React, { useEffect } from 'react';
import './index.scss';
import gifLoader from './ai_waiting_experience_alpha.gif';

interface AIAnimatedLoaderProps {
  isLoading?: boolean;
}

const AIAnimatedLoader: React.FC<AIAnimatedLoaderProps> = ({ isLoading = false }) => {
  // disabling scrollbar while the page is on loading
  useEffect(() => {
    document.body.style.overflowY = isLoading ? 'hidden' : 'auto';
  }, [isLoading]);

  return isLoading ? (
    <div className="aiAnimatedLoader-container">
      <img src={gifLoader} alt="Loading..." className="gif-loader" />
    </div>
  ) : null;
};

export default AIAnimatedLoader;